import { SxProps, Theme } from '@mui/system';
import ThemeConstants from '../../theme/ThemeConstants';

const styles = {
  container: {
    display: 'flex',
    flex: 1,
    justifyContent: 'center',
  },
  subContainer: {
    marginTop: '100px',
    maxWidth: 600,
    width: '100%',
  },
  title: {
    color: 'primary.main',
    fontSize: 22,
    fontWeight: '600',
  },
  name: {
    fontSize: 18,
    fontWeight: '600',
    color: 'common.grey850',
  },
  nameContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    mb: 1,
  },
  ratingContainer: {
    backgroundColor: 'secondary.main',
    padding: '16px 36px',
    maxWidth: 600,
    width: '100%',
    borderRadius: '4px',
    mt: 1,
  },
  commentField: {
    marginTop: 2,
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  error: {
    fontSize: 12,
    color: ThemeConstants.common.error,
  },
} satisfies Record<string, SxProps<Theme>>;

export default styles;
